/* eslint-disable */

/**
 * 
 * 
 * This component is auto-generated, please don't touch it!
 * 
 * 
 */

import * as React from "react";

function Jm(props) {
  return <svg width="1em" height="1em" viewBox="0 0 512 336" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none"><path d="M503.172.276H8.828A8.828 8.828 0 0 0 0 9.103v317.793a8.829 8.829 0 0 0 8.828 8.828h494.345a8.829 8.829 0 0 0 8.828-8.828V9.103a8.83 8.83 0 0 0-8.829-8.827z" fill="#73AF00" /><path d="M512 9.103a8.829 8.829 0 0 0-8.828-8.828h-39.501L256 136.337 48.329.276H8.828A8.828 8.828 0 0 0 0 9.103v22.836L207.671 168 0 304.061v22.836a8.829 8.829 0 0 0 8.828 8.828h39.501L256 199.663l207.671 136.061h39.501a8.829 8.829 0 0 0 8.828-8.828V304.06L304.329 168 512 31.939V9.103z" fill="#FFE15A" /><path d="M512 31.939v272.122L304.329 168zM0 304.061V31.939L207.671 168z" fill="#464655" /></g></svg>;
}

export default Jm;